import React from "react";
import { Link, useLocation } from "react-router-dom";
import { formatPrice, siteConfig } from "../Datas/productData";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { state } = useLocation();
  const order = state || {};

  return (
    <main className="payment-success" aria-labelledby="confirmation-title">
      <section className="payment-success__card" aria-live="polite">
        <div className="payment-success__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="img">
            <path d="m5 12.5 4.25 4.25L19.5 6.5" />
          </svg>
        </div>

        <p className="payment-success__eyebrow">Order confirmed</p>
        <h1 id="confirmation-title">Thank you for your order</h1>
        <p className="payment-success__intro">
          Your order has been received. We will email shipping updates
          {order.email ? ` to ${order.email}` : " as soon as it is on its way"}.
        </p>

        <dl className="payment-success__details">
          <div>
            <dt>Order number</dt>
            <dd>{order.orderNumber || "Confirmation pending"}</dd>
          </div>
          {order.itemCount != null && (
            <div>
              <dt>Items</dt>
              <dd>{order.itemCount}</dd>
            </div>
          )}
          {order.paymentLabel && (
            <div>
              <dt>Payment</dt>
              <dd>{order.paymentLabel}</dd>
            </div>
          )}
          {Number.isFinite(order.total) && (
            <div>
              <dt>Total</dt>
              <dd>{formatPrice(order.total)}</dd>
            </div>
          )}
        </dl>

        <div className="payment-success__actions">
          <Link className="payment-success__primary" to="/shop">
            Continue shopping
          </Link>
          <Link className="payment-success__secondary" to="/contact">
            Contact {siteConfig.displayName}
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
